


































































































/* eslint-disable @typescript-eslint/no-non-null-assertion */
import L from "leaflet"
import { Component, Watch } from "vue-property-decorator"
import { mixins } from "vue-class-component"
import MapMixin from "@/mixins/map"
import NotifyMixin from "@/mixins/notify"
import { addNewVenue } from "@/store/types/actions"
import {
    HAS_SELECTED_MARKET,
    GET_SELECTED_MARKET,
    GET_MAPBOX_STYLES_ID,
} from "@/store/types/getters"
import { VenueModule, MarketModule } from "@/consts"
import { Bind, Debounce } from "lodash-decorators"
import { notifyWarn } from "@/utils/notify"
import { AddVenue, Geometry } from "@/models"
import { isEmpty } from "@/utils/validate"
import { Getter } from "vuex-class"
import geodecode from "@/utils/geocode"
import { listCities, listStreets, listPostalCodes } from "@/utils/place"
import nop from "@/utils/nop"
import { Market } from "@/models"
import { AxiosError } from "axios"
import { validate as isValidPostalCode } from "postal-codes-js"

@Component
export default class SShopForm extends mixins(MapMixin, NotifyMixin) {
    private lat = 41.818213
    private lng = -87.665712
    private street: string | null = null
    private city: string | null = null
    private postcode: string | null = null

    private streetAutocompleteList: string[] = []
    private cityAutocompleteList: string[] = []
    private postalCodeAutocompleteList: string[] = []

    private isFetchingStreets = false
    private isFetchingCities = false
    private isFetchingPostcodes = false

    @MarketModule.Getter(HAS_SELECTED_MARKET) hasSelectedMarket!: boolean
    @MarketModule.Getter(GET_SELECTED_MARKET) selectedMarket!: Market | null

    @VenueModule.Action(addNewVenue) addNewVenue!: (paylaod: AddVenue) => void

    @Getter(GET_MAPBOX_STYLES_ID) private mapboxStylesId!: string

    private onLatLngChange(n: L.LatLng) {
        this.lat = n.lat
        this.lng = n.lng
    }

    private get selectedCountryISO() {
        return this.hasSelectedMarket
            ? this.selectedMarket!.country_iso
            : undefined
    }

    private get fullAddress() {
        return `${this.street}, ${this.city}`
    }

    @Bind
    @Debounce(250)
    private getCityAutocompleteList(input: string) {
        this.isFetchingCities = true
        listCities(input, this.selectedCountryISO)
            .then((cities: string[]) => {
                this.cityAutocompleteList = cities
            })
            .catch(nop)
            .finally(() => {
                this.isFetchingCities = false
            })
    }

    @Bind
    @Debounce(250)
    private getStreetAutocompleteList(input: string) {
        this.isFetchingStreets = true
        listStreets(input, this.selectedCountryISO)
            .then((streets: string[]) => {
                this.streetAutocompleteList = streets
            })
            .catch(nop)
            .finally(() => {
                this.isFetchingStreets = false
            })
    }

    @Bind
    @Debounce(250)
    private getPostalCodeAutocompleteList(input: string) {
        this.isFetchingPostcodes = true
        listPostalCodes(input, this.selectedCountryISO)
            .then((streets: string[]) => {
                this.postalCodeAutocompleteList = streets
            })
            .catch(nop)
            .finally(() => {
                this.isFetchingPostcodes = false
            })
    }

    @Watch("fullAddress", { immediate: false, deep: false })
    @Bind
    @Debounce(250)
    private onFullAddressChange(n: string) {
        if (isEmpty(n)) {
            return
        }

        geodecode(n)
            .then((res: Geometry[]) => {
                if (res.length) {
                    const { lat, lng } = res[0].location

                    this.latLng = L.latLng(lat, lng)
                    this.center = L.latLng(lat, lng)
                }
            })
            .catch((err: AxiosError) => {
                this.notifyRequestError(
                    err,
                    "failed to autocomplete gps location"
                )
            })
    }

    private onClose() {
        this.$modal.hide("SShopForm")
    }

    private onAddShop() {
        if (!this.hasSelectedMarket) {
            return notifyWarn(
                "Operation ignored",
                "You haven't chosen any customer"
            )
        }

        if (
            isEmpty(this.street) ||
            isEmpty(this.city) ||
            isEmpty(this.postcode)
        ) {
            return notifyWarn("Operation cancelled", "Please fill in the form")
        }

        if (!isValidPostalCode(this.selectedCountryISO!, this.postcode!)) {
            return notifyWarn("Operation cancelled", "Invalid postCode")
        }

        const payload: AddVenue = {
            street: this.street as string,
            city: this.city as string,
            postcode: this.postcode as string,
            lat: this.lat,
            lng: this.lng,
        }

        this.addNewVenue(payload)
    }
}
